import * as React from 'react';
/**
 *
 * Original name: sound off
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2991%3A274
 *
 */
export const SoundOffFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m14.5 13.142-4.226 4.227L14.5 20.25v-7.108Zm-9.06 6.94-1-1 2.597-2.598C4.995 16.34 4 15.195 4 13c0-2.355 1.145-3.5 3.5-3.5H9l5.5-3.75v3.27l4.081-4.08 1 1L5.44 20.081Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
